import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { LoginIpWhitelist } from '../../interfaces/configuration/login-ip-whitelist';

@Injectable()

export class LoginIpWhitelistService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<LoginIpWhitelist[] | boolean> {
    return new Observable<LoginIpWhitelist[] | boolean>((o: Subscriber<LoginIpWhitelist[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.login-ip-whitelist.index')).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<LoginIpWhitelist[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<LoginIpWhitelist | boolean> {
    return new Observable<LoginIpWhitelist | boolean>((o: Subscriber<LoginIpWhitelist | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('configuration.login-ip-whitelist.read', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<LoginIpWhitelist>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('configuration.login-ip-whitelist.create'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('configuration.login-ip-whitelist.update', {':id': id}), formData);
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('configuration.login-ip-whitelist.delete', {':id': id})).subscribe(
        (response: ServerResponse): void => {
          if (!this.api.isErrorResponse(response)) {
            o.next(true);
          } else {
            o.next(false);
          }
        },
        (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
